module.exports = __webpack_public_path__ + "img/item1.caec68b7.png";